import en from '@/localization/en';

export const getErrorText = (key: string, defaultKey: string) => {
  const errorKey = key as keyof en;
  const errorMessage = en[errorKey] ?? errorKey;
  return errorMessage || defaultKey;
};
